import Config from '../config/Config';

export const appendScript = (scriptToAppend) => {
	const { ASSETSPATH } = Config;
	const script = document.createElement('script');
	script.src = `${ASSETSPATH}js/${scriptToAppend}.js`;
	script.async = true;
	document.body.appendChild(script);
};
